
import { Component, Vue } from "vue-property-decorator";
import { Toast } from "vant";
import { StoreProductService } from "src/services";
import pageBack from "src/components/page-back";
import vueWaterfallEasy from 'src/utils/vue-waterfall-easy/vueWaterfallEasy';

@Component({
    components:
    {
        pageBack,
        vueWaterfallEasy,
    }
})
 export default class PhysicalPackageList extends Vue
 {
    /**
     * 产品分类
     * @private
     * @returns Array<any>
     */
    private storeProductType: Array<any> = [];

    /**
    * 是否选择城市弹框
    * @private
    * @returns boolean
    */
    private showCity: boolean = false;

    /**
     * 体检套餐列表（按ids查询）
     * @private
     * @returns void
     */
    public physicalPackageList = [];

    /**
     * loading
     */
    private loading: boolean = false;

    /**
     * 当前页码
     */
    private pageIndex: number = 0;

    /**
     * 体检套餐列表（全量查询）
     * @private
     * @returns void
     */
     private products: Array<any> = [];

    /**
     * 查询条件
     * @private
     * @returns void
     */
    private filters: any = {
        key: '',
        cityName: '',
    };

    /**
     * 分类类型
     * @private
     * @returns number
     */
    private currentProductType: number = -1;

    /**
    * 选中位置
    * @private
    * @returns any
    */
    private get currentLocaltion(): any
    {
        if (this.$store.getters.currentLocaltion) {
            this.filters.cityName = this.$store.getters.currentLocaltion;
        }
        else {
            this.filters.cityName = '深圳市';
        }
        return this.$store.getters.currentLocaltion;
    }
    
    /**
    * 是否全选
    * @private
    * @returns any
    */
    private get checkedAll(): any
    {
        return this.$route.query && (this.$route.query.checkedAll as any) || false;
    }

    /**
    * 是否是全部产品
    * @private
    * @returns any
    */
    private get isAllProduct(): any
    {
        return this.$route.query && (this.$route.query.isAllProduct as any) || false;
    }

    /**
     * ids
     * @private
     * @returns Array<number>
     */
    private get ids()
    {
        let ids = [];
        if (!this.checkedAll && localStorage.getItem("allProductList"))
        {
            if (this.isAllProduct) {
                ids = JSON.parse(localStorage.getItem("allProductList"));
            }
        }
        if (!this.checkedAll && localStorage.getItem("productList")) {
            if (!this.isAllProduct) {
                ids = JSON.parse(localStorage.getItem("productList"));
            }
        }
        return ids;
    }

    /**
     * 分类ids
     * @private
     * @returns Array<number>
     */
    private get productCategoryIds()
    {
        let ids = [];
        if (!this.checkedAll && localStorage.getItem("allProductCategoryIds"))
        {
            if (this.isAllProduct) {
                ids = JSON.parse(localStorage.getItem("allProductCategoryIds"));
            }
        }
        if (!this.checkedAll && localStorage.getItem("productCategoryIds")) {
            if (!this.isAllProduct) {
                ids = JSON.parse(localStorage.getItem("productCategoryIds"));
            }
        }
        return ids;
    }

    /**
     * 分类ids
     * @private
     * @returns Array<number>
     */
    private get categoryIds()
    {
        let ids = [];
        if (this.isAllProduct)
        {
            // 全部产品
            ids = this.storeProductType;
        }
        else {
            ids = this.storeProductType.filter(item => item.productType !== 0);
        }
        if (this.productCategoryIds && this.productCategoryIds.length > 0) {
            ids = this.storeProductType.filter(item => this.productCategoryIds.includes(item.productType));
        }
        
        return ids;
    }
    
    /**
     * 组件创建钩子
     */
    protected async created()
    {
        await this.getStoreProductType();
        await this.loadData({});
    }

    private onSearch(val: any) {
        console.log('val', val)
    }

    /**
     * 获取商品数据列表 
     */
    protected async loadData(parameter: any): Promise<any>
    {
        this.loading = true;
        try {
            let currentProductType: any = null;
            if(this.currentProductType != -1)
            {
                currentProductType = this.currentProductType;
            }
            this.pageIndex++;
            parameter = {
                pageIndex: this.pageIndex,
                pageSize: 10
            };
            // 不包含体检套餐
            let notInProductTypes = [];
            let PhysicalPackageProductType = 0;
            if (!this.isAllProduct) {
                notInProductTypes.push(PhysicalPackageProductType)
            }
            let params: any = {
                productType: currentProductType,
                notInProductTypes: notInProductTypes,
                ...this.filters,
                cityName: this.filters.cityName || this.currentLocaltion || '深圳市',
                ids: this.ids,
            };
            let { content: res } = await StoreProductService.instance.getStoreProduct(
                Object.assign({...params}, parameter)
            );

            let productListData = res.data;
            if (res.data.totalPages == 0)
            {
                (this.$refs.waterfall as any).waterfallOver();
            }
            else
            {
                if (res.data.items)
                {
                    this.products = this.products.concat(productListData.items);
                    this.products.forEach(p => p.src = "");
                }

                if (this.pageIndex == res.data.totalPages)
                {
                    setTimeout(() =>
                    {
                        (this.$refs.waterfall as any).waterfallOver();
                    }, 1);
                }
            }

            return res.data;
        } catch (err) {
            Toast(err);
        }
        finally
        {
            this.loading = false;
        }
    }

    /**
     * 获取商品分类
     */
     protected async getStoreProductType(): Promise<any>
    {
        try {
            let cityName = this.filters.cityName || this.currentLocaltion || '深圳市';
            let { content: res } = await StoreProductService.instance.getStoreProductType(cityName);
        
            if(res.data && res.data.length)
            {

                this.storeProductType = res.data;
            }
        } catch (err) {
            Toast(err);
        }
    }

    /**
     * 点击分类
     */
    protected onCategoryClick(type: number): void
    {
        this.currentProductType = type;
        this.onRefresh();
    }

    /**
     * 搜索
     */
    protected onRefresh(): void
    {
        this.products = [];
        this.physicalPackageList = [];
        this.pageIndex = 0;
        this.loadData({});
    }

    /*
    * 显示城市组件弹框
    * @private
    * @returns void
    */
    private onShowCityModel(): void
    {
        this.showCity = true;
    }

    /*
    * 选择城市
    * @private
    * @returns void
    */
    private async onSelectCity(city: string): Promise<any>
    {
        this.filters.cityName = city;
        this.showCity = false;
        await this.getStoreProductType();
        await this.loadData({});
    }

    /**
     * 跳转体检套餐详情
     * @private
     * @returns void
     */
    private onPackageDetail(item) {
        // 体检套餐 PhysicalPackage = 0
        // 医疗服务 MedicalService = 2
        // 实物 Goods = 4
        // 健管服务 HealthManageService = 6
        // 问诊购药 DiagMedicine = 2002
        // 就医绿通 Greenway = 2004
        // 齿科服务 Dental = 2006
        // 眼科服务 Eye = 2008
        // 疫苗服务 Vaccine = 2010
        // 中医服务 TCM = 2012
        // 轻医美 MedicalBeauty = 2014

        if(item.productType == 0)
        {
            // 体检套餐
            this.$router.push({name: "package-detail", query:{id: item.targetId, productId: item.id}});
        }
        else if(item.productType == 4)
        {
            // 实物套餐
            this.$router.push({name: "goodsDetail", query:{id: item.targetId, productId: item.id}});
        }
        else if(item.productType == 8)
        {
            // 健康险产品
            this.$router.push({name: "healthInsuranceDetail", query:{id: item.targetId}});
        }
        else
        {
            this.$router.push({name:"medical", query:{id:item.targetId, productId: item.id}});
        }
    }
 }
